import { Avatar, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { Link } from "react-router";
import type { Assistant } from "@/domain/assistant/types";

type Props = {
  assistant: Assistant;
};

export function AssistantCard({ assistant }: Props) {
  return (
    <Card variant="outlined">
      <CardActionArea component={Link} to={`/chat/${assistant.id}`}>
        <CardContent sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
          <Avatar
            variant="rounded"
            sx={{
              bgcolor: "primary.light",
              width: 48,
              height: 48,
              flexShrink: 0,
            }}
          >
            {assistant.name.charAt(0).toUpperCase()}
          </Avatar>
          <div>
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              {assistant.name}
            </Typography>
            {assistant.description && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mt: 0.5,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {assistant.description}
              </Typography>
            )}
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
